import React from "react";
import { Link } from "react-router-dom";

import "./Header.css";

import Cover from "../Cover/Cover";
import HamburgerButton from "./MenuButton";

export const routes = [
    // {title: "Главная", href: "/"},
    // {title: "О компании", href: '/company/'},
    // {title: "Контакты", href: '/contacts'},
];

function Header() {
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  function setWidth() {
    setWindowWidth(window.innerWidth);
  }

  React.useEffect(() => {
    window.addEventListener('resize', setWidth);
    return () => {
        window.removeEventListener('resize', setWidth);
    };
  });

  return (
    <header>
      <div className="header__container">
        <div className="header__logo"></div>
        <div className="header__link-container">
          {routes.map((route) => {
            const { href, title } = route;
            return (
              <Link className="header__link" to={href}> {title} </Link>
            )
          })}
        </div>
        {/* <HamburgerButton style={{border: '0.1px red'}}/> */}
      </div>
      <Cover covermode="Home" windowWidth={windowWidth}/>
    </header>
  );
}

export default Header;
